import axios from "axios";
import store from "../services/store";

const user = store.getState()?.user?.user;

const getAuthHeaders = (user, headers = {}) => {
  if (user && user.auth_token) {
    return { ...headers, Authorization: `Bearer ${user.auth_token}` };
  }
  return headers;
};

const getAuthPayload = (user, data = null) => {
  if (user && user.success) {
    return { ...data, token: user.auth_token, user_id: user.id };
  }
  return data;
};

export const flatten = (obj, prefix = "") => {
  const result = {};
  for (const [key, value] of Object.entries(obj)) {
    const prefixed = prefix ? `${prefix}[${key}]` : key;
    if (typeof value === "object" && !Array.isArray(value)) {
      Object.assign(result, flatten(value, prefixed));
    } else if (Array.isArray(value)) {
      value.forEach((val, i) => {
        Object.assign(result, flatten(val, `${prefixed}[${i}]`));
      });
    } else {
      result[prefixed] = value;
    }
  }
  return result;
};

const apiCall = async ({ method, url, data = null, headers = null }) => {
  const authHeaders = getAuthHeaders(user, headers);
  const authPayload = getAuthPayload(user, data);
  return await axios({
    method,
    url,
    data: authPayload,
    headers: authHeaders,
  });
};

export default apiCall;
